import { StepperOrientation } from "@angular/cdk/stepper";
import { Modes } from "./modes";

export class AppConstants {
  static COMPLETED_AT_ORG(
    COMPLETED_AT_ORG: any
  ): import("@angular/forms").AbstractControl<any, any> {
    throw new Error("Method not implemented.");
  }
  //SCORM-related constants
  static readonly SUSPEND_DATA: string = "cmi.suspend_data";
  static readonly CORE_ENTRY: string = "cmi.core.entry";
  static readonly CORE_EXIT: string = "cmi.core.exit";
  static readonly CORE_TOTAL_TIME: string = "cmi.core.total_time";
  static readonly CORE_STUDENT_NAME: string = "cmi.core.student_name";
  static readonly CORE_STUDENTID_OR_DOB: string = "cmi.core.student_id_or_dob";
  static readonly CORE_LESSON_STATUS: string = "cmi.core.lesson_status";
  static readonly CORE_LAUNCH_DATA: string = "cmi.launch_data";
  static readonly CORE_SESSION_TIME = "cmi.core.session_time";
  static readonly OBJECT_ID: string = "objectId";
  static readonly OBJECT_NAME: string = "objectName";
  static readonly FROM_LEARNING_RECORD_TAB: string = "fromLearningRecordTab";
  static readonly FROM_VIEW_LEARNING_PLAN: string = "fromViewLearningPlan";
  static readonly FROM_EDIT_LEARNING_PLAN: string = "fromEditLearningPlan";
  static readonly FROM_MANUAL_EDIT_LEARNING_PLAN: string =
    "fromManualEditLearningPlan";
  static readonly FROM_LEARNING_RESOURCES: string = "fromLearningResources";
  static readonly FROM_LEARNING_PLAN: string = "fromLearningPlan";
  static readonly FROM_LEARNER_RESOURCES: string = "fromLearnerResources";
  static readonly DEFAULT_TIME: string = "00:00:00";
  static readonly BLANK: string = "";
  static readonly SINGLE_SPACE: string = " ";
  static readonly SUSPEND: string = "suspend";
  static readonly COMPLETED_STATUS: string = "completed";
  static readonly SCORM_LO_FILE: string = "/lo.html";
  static readonly SCORM_MODE: string = "mode";
  static readonly SCORM_QUERY_PARAM_PREFIX: string = "?QID=";
  static readonly SCORM_SC_QUERY_PARAM_PREFIX: string = "&QID=";
  static readonly CONTENT_REPLACED: string = "/content_replaced/";
  static readonly VISITED: string = "visited";
  static readonly SCORM_ENTRY: string = "scormEntry";
  static readonly LEARNER: string = "learner";
  static readonly SCORM_SESSION: string = "ScormSession";
  static readonly SCORM_ENTRY_EDIT: string = "scormEntryId";
  static readonly SESSION_ID: string = "sessionId";
  static readonly SCORM_COMPLETION_INPROGRESS_KEY: string = "scormCompletionInProgress";

  //Constant elements
  static readonly MAIN_HEADER: string = "main-header";

  //UserProfile fields
  static readonly USERNAME: string = "username";
  static readonly USER_PROFILE_ID: string = "userProfileId";
  static readonly USER_PROFILE: string = "userProfile";
  static readonly ROLE_ID: string = "roleId";
  static readonly FIRST_NAME: string = "firstName";
  static readonly LAST_NAME: string = "lastName";
  static readonly PASSWORD: string = "password";
  static readonly CURRENT_PASSWORD: string = "currentPassword";
  static readonly NEW_PASSWORD: string = "newPassword";
  static readonly CONFIRM_PASSWORD: string = "confirmPassword";
  static readonly EMAIL: string = "email";
  static readonly CURRENT_EMAIL: string = "currentEmail";
  static readonly NEW_EMAIL: string = "newEmail";
  static readonly CONFIRM_EMAIL: string = "confirmEmail";
  static readonly LOGIN: string = "login";
  static readonly LOGIN_DETAILS: string = "loginDetails";
  static readonly PERSONAL_DETAILS: string = "personalDetails";
  static readonly ORGANISATION_ID: string = "(LN02)";
  static readonly GLOBALLY_UNIQUE_ID: string = "(ULN)";
  static readonly UNIQUE_LEARNER_NUMBER: string = "uniqueLearnerNumber";
  static readonly LEARNER_NUMBER02: string = "learnerNumber02";
  static readonly COURSES: string = "Courses";
  static readonly LAST_LOGIN_DATE: string = "lastLoginDate";
  static readonly OVERALL_ACTIVITY_DATE: string = "overallActivityDate";
  static readonly ACTIVITY_DATE: string = "activityDate";
  static readonly ACCOUNT_STATUS: string = "accountStatus";

  static readonly USER_SAME_EMAIL_EN: string =
    "Current email and New email should not be the same.";
  static readonly USER_SAME_EMAIL: string = $localize`:@@same-current-email:Current email and New email should not be the same.`;

  static readonly USER_SUCCESSFUL_UPDATE_MESSAGE: string =
    "Your profile was successfully updated.";
  static readonly USER_UNSUCCESSFUL_UPDATE_MESSAGE: string =
    "Your profile was not updated.";
  static readonly ADMIN_NO_SELECTED_MESSAGE: string =
    "You have not selected any administrators.";
  static readonly LEARNER_NO_SELECTED_MESSAGE: string = $localize`:@@you-have-not-selected:You have not selected any learners.`;
  static readonly SELECTED_INVALID_LEARNER_MESSAGE: string = $localize`:@@selected-invalid-learner:You have selected an invalid learner`;
  static readonly GROUP_NO_SELECTED_MESSAGE: string = $localize`:@@not-selected-any-groups:You have not selected any groups.`;
  static readonly GROUPS_ARE_NOT_ASSOCIATED_WITH_ANY_LEARNER = $localize`:@@groups-are-not-associated-with-learners:Groups are not associated with any learners.`;
  static readonly CATEGORIES_NO_SELECTED_MESSAGE: string = $localize`:@@no-selected-categories:You have not selected any categories.`;
  static readonly CATEGORIES_SUCCESSFUL_ADDED_MESSAGE: string = $localize`:@@success-add-category:Categories added successfully.`;
  static readonly ADMIN_SUCCESSFUL_DELETE_MESSAGE: string =
    "Admins deleted successfully.";
  static readonly LEARNER_SUCCESSFUL_DELETE_MESSAGE: string =
    "Learners deleted successfully.";
  static readonly GROUP_SUCCESSFUL_DELETE_MESSAGE: string =
    "Groups deleted successfully.";
  static readonly CENTRE_SUCCESSFUL_DELETE_MESSAGE: string =
    "Centre deleted successfully.";
  static readonly LEARNER_SUCCESSFUL_ENABLED_MESSAGE: string = $localize`:@@learners-enabled:Learners enabled successfully.`;
  static readonly LEARNER_SUCCESSFUL_DISABLED_MESSAGE: string = $localize`:@@learners-disabled:Learners disabled successfully.`;
  static readonly LEARNER_ERROR_ENABLED_MESSAGE: string =
    "Failed to enable learners. One or more selected learners could not be enabled.";
  static readonly LEARNER_ERROR_DELETE_MESSAGE: string =
    "Failed to delete learners. One or more selected learners could not be deleted.";
  static readonly SEARCH: string = $localize`:@@search:Search`;
  static readonly ADMIN_FAILED_DELETE_GENERIC_MESSAGE: string =
    "Admins delete failed. Please try again.";
  static readonly ADMIN_FAILED_API_GENERIC_MESSAGE: string =
    "Operation failed. UserProfile/s not deleted";
  static readonly USER_NOT_FOUND: string = "User not found";
  static readonly TUTOR_SUCCESSFUL_ENABLED_MESSAGE: string = $localize`:@@tutors-enabled:Tutors enabled successfully.`;
  static readonly TUTOR_SUCCESSFUL_DISABLED_MESSAGE: string = $localize`:@@tutors-disabled:Tutors disabled successfully.`;
  static readonly ORG_ADMIN_SUCCESSFUL_ENABLED_MESSAGE: string = $localize`:@@org-admin-enabled:Organisation Administrators enabled successfully.`;
  static readonly ORG_ADMIN_SUCCESSFUL_DISABLED_MESSAGE: string = $localize`:@@org-admin-disabled:Organisation Administrators disabled successfully.`;
  static readonly GLOBAL_ADMIN_SUCCESSFUL_ENABLED_MESSAGE: string = $localize`:@@global-admin-enabled:Global Administrators enabled successfully.`;
  static readonly GLOBAL_ADMIN_SUCCESSFUL_DISABLED_MESSAGE: string = $localize`:@@global-admin-disabled:Global Administrators disabled successfully.`;
  static readonly ADMIN_SUCCESSFUL_ENABLED_MESSAGE: string = $localize`:@@admin-enabled:Administrators enabled successfully.`;
  static readonly ADMIN_SUCCESSFUL_DISABLED_MESSAGE: string = $localize`:@@admin-disabled:Administrators disabled successfully.`;

  static readonly FAILED_SERVICE_RESPONSE: string =
    "Failed service request. Please try to reload.";

  //Create Learner Constants SnackBar
  static readonly LEARNER_ADDED_SUCCESS: string = $localize`:@@learner-added-success:Successfully added Learner`;
  static readonly LEARNER_ADD_FAILED: string = $localize`:@@learner-adding-failed:Failed adding Learner`;

  //Assign Course to Learner Constants SnackBar
  static readonly ASSIGN_COURSE_NUM_LEARNERS_SUCCESS: string = $localize`:@@course-assign-num-learners-success:Learners' courses were successfully assigned/updated`;

  //Create admin constatns snackbar
  static readonly ADMIN_ADD_SUCCESS: string = $localize`:@@success-add-admin:Successfully added administrator`;
  static readonly ADMIN_ADD_FAILED: string = $localize`:@@failed-add-admin:Failed: Adding administrator. Please try again.`;
  //Generic HostListener Component
  static readonly WIN_BEFOREUNLOAD: string = "window:beforeunload";
  static readonly WIN_RESIZE: string = "window:resize";
  static readonly EVENT_PROP: string = "$event";
  static readonly KEY_DOWN: string = "keydown";
  static readonly BACKSPACE: string = "Backspace";

  //Common Control Directives
  static readonly FORM_DIRECTIVE: string = "formDirective";
  static readonly STEPPER: string = "stepper";
  static readonly STEPPER_HORIZONTAL: string = "stepperHorizontal";
  static readonly STEPPER_VERICAL: string = "stepperVertical";

  //Administrator fields and text
  static readonly ID: string = "id";
  static readonly ADMIN_ID: string = "adminId";
  static readonly ADMINISTRATOR: string = "administrator";
  static readonly ORGANISATION: string = "organisationId";
  static readonly ORGANISATION_CTRL: string = "organisation";
  static readonly CENTRE_ID: string = "centreId";
  static readonly ORGANISATION_NAME: string = "organisationName";
  static readonly CENTRE_NAME: string = "centreName";
  static readonly ORG_CENTRE_COUNT = "organisationCentreCount";
  static readonly ORGANISATION_IDS = "organisationIds";
  static readonly ORGANISATION_SELECTED = $localize`:@@organisation-selected:Organisation selected`;
  static readonly ORGANISATIONS_SELECTED = $localize`:@@organisations-selected:Organisations selected`;
  static readonly LIST_OF_SELECTED_ORGANISATION = $localize`:@@list-selected-organisation:List of selected Organisation`;
  static readonly LIST_OF_SELECTED_ORGANISATIONS = $localize`:@@list-selected-organisations:List of selected Organisations`;
  static readonly ORGANISATION_ASSIGNED = $localize`:@@organisation-assigned:Organisation assigned`;
  static readonly ORGANISATIONS_ASSIGNED = $localize`:@@organisations-assigned:Organisations assigned`;
  //All Centre and All Org
  static readonly ALL_CENTRE = "AllCentre";
  static readonly ALL_CENTRE_SPC = "All Centre";
  static readonly ALL_ORG = "AllOrg";

  //Validation dummy control
  static readonly PROCEED_CTRL: string = "proceed";
  //Role fields
  static readonly ROLE: string = "role";

  //Course fields
  static readonly COURSE_ID: string = "courseId";
  static readonly COURSE: string = "course";
  static readonly APP_NUM: string = "application-of-number";
  static readonly COM_ENG: string = "communication-english";
  static readonly COM_WEL: string = "communication-welsh";
  static readonly DIG_LIT: string = "digital-literacy";
  static readonly ESOL: string = "esol";
  static readonly DIG_LIT_SA: string = "digital-literacy-sa";

  //CourseContentMetadata constants
  static readonly PRACTICE_ASSESSMENT: string = "practice-assessment";
  static readonly SCREENER: string = "screener";
  static readonly SCREENER_OBJ_ID: string = "screenerObjectId";

  //Courses list table headers
  static readonly COURSES_LIST: string = $localize`:@@course-list:Courses list`;
  static readonly COURSE_NAME: string = "courseName";
  static readonly STATUS_COLUMN: string = "status";
  static readonly START_LEVEL_COLUMN: string = "startLevel";
  static readonly CURRENT_PROGRESS_COLUMN: string = "currentProgress";
  static readonly CURRENT: string = "CURRENT";
  static readonly PREVIOUS: string = "PREVIOUS";
  static readonly INITIAL_ASSESSMENT_RESULT: string = "initialAssessmentResult";

  //Course Status
  static readonly NOT_STARTED: string = "Not Started";
  static readonly IN_PROGRESS: string = "In Progress";
  static readonly NOT_ASSIGNED: string = "Not Assigned";
  static readonly ASSIGNED: string = "assigned";
  static readonly UNASSIGNED: string = "unassigned";
  static readonly INCOMPLETE: string = "incomplete";

  //Language constants
  static readonly WELSH_LANG_CODE: string = "cy";
  static readonly WELSH_GB_LANG_CODE: string = "cy-GB";
  static readonly DEFAULT_LANG_CODE: string = "en-US";
  static readonly EN_GB_LANG_CODE: string = "en-GB";
  static readonly VALID_LANG_CODES: string[] = [
    AppConstants.WELSH_LANG_CODE,
    AppConstants.DEFAULT_LANG_CODE,
  ];
  static readonly LANG_CODE: string = "langCode";
  static readonly LANG_ID: string = "langId";
  //Translation keys constants
  static readonly CONFIRM_MESSAGE_ALERT: string = "confirm-message-alert";

  //SessionStorage-specific constants
  static readonly SCREENER_ID: string = "sc_id";
  static readonly PREV_PATH: string = "previousPath";
  static readonly NEXT_PATH: string = "nextPath";
  static readonly URL_QUERY_DELIM: string = "?";

  //SessionStorage-specific constants
  static readonly NG2IDLE_EXPIRY = "ng2Idle.main.expiry";

  //LearnerLog fields
  static readonly LCL_ID: string = "lcLogId";
  static readonly LC_START_LEVEL: string = "lcStartLevel";
  static readonly LEARNER_ID: string = "learnerId";
  static readonly COURSE_STEP_ID: string = "courseStepId";

  //Url page constants
  static readonly BLANK_PAGE: string = "_blank";
  static readonly LOCALHOST: string = "localhost";
  static readonly CONTENT_PLAYER_PAGE: string = "/contentplayer";
  static readonly FSCONTENT_PLAYER_PAGE: string = "/fscontentplayer";
  static readonly LEARNER_COURSE_PAGE: string = "/learner-course";
  static readonly WELCOME_PAGE: string = "/welcome";
  static readonly CONTACT_US_PAGE: string = "/contact-us";
  static readonly PRIVACY_POLICY_PAGE: string = "/privacy-policy";
  static readonly COPYRIGHT_PAGE: string = "/copyright";
  static readonly ACCESSIBILITY_PAGE: string = "/accessibility";
  static readonly DASHBOARD_PAGE: string = "/dashboard";
  static readonly LEARNING_PLAN_PAGE: string = "/learning-plan";
  static readonly LEARNING_PAGE: string = "/learning";
  static readonly SCREENER_PAGE: string = "/screener";
  static readonly QANDA_PAGE: string = "/q-and-a";
  static readonly EXTERNAL_LINK_PAGE: string = "/external-link";
  static readonly ADMIN: string = "admin";
  static readonly ADMIN_PAGE: string = "dashboard/admin";
  static readonly ADMIN_EDIT: string = "edit-admin";
  static readonly USERS_PAGE: string = "users";
  static readonly GROUPS_PAGE: string = "groups";
  static readonly ORG_AND_CENTRE_PAGE: string = "organisation-and-centre";
  static readonly ADMINISTRATORS_PAGE: string = "administrators";
  static readonly UPDATE_ADMIN: string = "/updateadmin";
  static readonly GET_ADMIN_EMAIL: string = "/getadministratoremail";
  static readonly CENTRE_LIST: string = "list-centre";
  static readonly ORGANISATION_LIST: string = "list-organisation";
  static readonly ADMIN_DASHBOARD_LEARNERS_PAGE =
    "dashboard/admin/users/learners";
  static readonly ADMIN_DASHBOARD_LIST_ORG_PAGE =
    "dashboard/admin/organisation-and-centre/organisation/list-organisation";
  static readonly CENTRE_VIEW_PAGE: string = "view-centre";
  static readonly ORG_VIEW_PAGE: string = "view-org";
  static readonly GROUP_LIST: string = "list-group";
  static readonly EDIT_ORG_PAGE: string = "edit-org";
  static readonly TUTOR_LIST: string = "tutor-list";
  static readonly EDIT_TUTOR: string = "edit-tutor";
  static readonly TUTOR_RESOURCES: string = "tutor-resources";
  static readonly ADMINISTRATOR_LIST: string = "administrator-list";
  static readonly LEARNER_LIST: string = "list";
  static readonly TUTOR_PAGE = "dashboard/tutor";
  static readonly VIEW_LEARNER = "view-learner";
  static readonly ADD_OFFLINE_ACTIVITY = "add-offline-activity";
  static readonly EDIT_OFFLINE_ACTIVITY = "edit-offline-activity";
  static readonly LEARNER_PROFILE = $localize`:@@learner-profile:Learner profile`;
  static readonly LEARNER_HISTORY = $localize`:@@learner-history:Learner history`;
  static readonly VIEW_LEARNING_PLAN = "view-learning-plan";
  static readonly LEARNING_RECORD = "learning-record";
  static readonly EDIT_GROUP: string = "edit-group";
  static readonly EDIT: string = "edit";
  static readonly MANUAL_EDIT: string = "manualedit";
  static readonly LEARNING_RESOURCES_FROM_LEARNING_PLAN = "learning-resources";
  static readonly CREATE_EXTERNAL_INITIAL_ASSESSMENT: string =
    "create-external-initial-assessment";
  static readonly LEARNER_RESOURCES: string = "learner-resources";
  static readonly LEARNER_RESOURCES_LIST: string = "learner-resources-list";
  static readonly VIEW_LEARNER_RESOURCES: string = "view-learner-resources";
  static readonly SELF_ASSESSMENT_TAB: string = "self-assessment-tab";
  static readonly ASSIGN_COURSE_MULTI_LEARNERS_PAGE =
    "assign-course-to-multiple-learners";
  static readonly REPORTS_PAGE: string = "reports";
  static readonly FSCONTENT_PLAYER_PATH: string = "fscontentplayer-path";
  //Manually add here routes to be excluded in popstate event
  static readonly NON_REDIRECTABLE_ROUTES: string[] = [
    "create-centre",
    "create-organisation",
    "create-userprofile",
    "create-admin",
    "edit-admin",
    "update-userprofile",
    "edit-centre",
    "edit-org",
  ];
  static readonly ADMIN_DASHBOARD_LIST_GROUP_PAGE =
    "dashboard/admin/groups/list-group";
  static readonly TUTOR_DASHBOARD_LIST_GROUP_PAGE =
    "dashboard/tutor/groups/list-group";
  static readonly ADMIN_DASHBOARD_LEARNER_LIST_PAGE =
    "dashboard/admin/users/learners/list";
  static readonly TUTOR_DASHBOARD_LEARNER_LIST_PAGE = "dashboard/tutor/list";
  static readonly ADMIN_DASHBOARD_LEARNER_VIEW_LEARNER =
    "dashboard/admin/users/learners/view-learner";
  static readonly TUTOR_DASHBOARD_LEARNER_VIEW_LEARNER =
    "dashboard/tutor/view-learner";
  static readonly MSAL_SIGNED_IN_PAGE: string = "/msalsignedin";

  //Navigation property
  static readonly NAVIGATION_ID: string = "navigationId";
  static readonly NAVIGATION: string = "navigation";

  //Assessment Question
  static readonly QUESTION_ID: string = "qId";
  static readonly SAVED_QSET_PANEL_STATE: string = "savedQsetPanelState";

  // Router Events
  static readonly POPSTATE: string = "popstate";
  static readonly IMPERATIVE: string = "imperative";

  //Tab Evebts
  static readonly QA_TAB_INDEX: string = "qaTabIndex";

  //Scorm nav query
  static readonly RESULT_ELEMENT: string = "div#summary_detail";
  static readonly SCORM_LOADER = "#scormLoader";
  static readonly SCORM_WRAPPER = ".scormWrapper";
  static readonly SCORM_CURTAIN_IMAGE = ".curtainImage";
  static readonly SCORM_FRAME = "#scormFrame";
  static readonly LESSON_TRACKED_MODE = "mode=" + Modes.LessonTracked;

  static readonly OVERALL_NO_LEVEL_ACHIEVED_RESULT = $localize`:@@overall-no-level-result:Please talk to your tutor.`;

  static readonly WEST_BROADCAST_CHANNEL = "WEST Broadcast Channel";

  static readonly ON_SESSION_TIMEOUT = "onSessiontTimeOut";
  static readonly ON_USER_LOGOUT = "onUserLogout";

  static readonly DOCUMENT_INTERRUPT_CONFIG =
    "mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll";
  static readonly TOUCHSTART: string = "touchstart";
  //Matdialog ID
  static readonly SESSION_TIMEOUT_WARNING_ID = "session-timeout-warning-pop-up";
  static readonly DELETE_ADMIN_ID = "delete-admin-pop-up";
  static readonly DELETE_TUTOR_DIALOG_ID = "delete-tutor-dialog";
  static readonly DELETE_LEARNER_ID = "delete-learner-pop-up";
  static readonly DELETE_GROUP_ID = "delete-group-pop-up";
  static readonly DELETE_CENTRE_ID = "delete-centre-pop-up";
  static readonly UPDATE_STATUS_LEARNER_ID = "update-status-learner-pop-up";
  static readonly LEARNING_RECORD_HISTORY_DIALOG_ID =
    "learning-record-history-dialog";
  static readonly ADD_OFFLINE_ACTIVITY_DIALOG_ID =
    "add-offline-activity-dialog";
  static readonly CONTENT_REPLACED_DIALOG_ID = "content-replaced-pop-up";
  static readonly POP_UP_REMINDER = "pop-up-reminder-dialog";
  static readonly ACTIVITY_DIALOG: string = "activity-details-dialog";
  static readonly ADD_LEARNING_RESOURCES_DIALOG_ID: string =
    "add-learning-resources-dialog";
  static readonly REMOVE_LEARNING_RESOURCES_DIALOG_ID: string =
    "remove-learning-resources-dialog";
  static readonly DUE_DATE_DIALOG_ID: string = "due-date-dialog";
  static readonly FS_PLAYER_DIALOG_ID = "fs-player-message-dialog";
  static readonly IMPORT_EXT_RESULTS_INFO_DIALOG_ID =
    "import-external-results-info-dialog";
  static readonly UPDATE_TUTOR_ACCOUNT_STATUS_DIALOG_ID =
    "update-tutor-account-status-dialog";
  static readonly UPDATE_ADMIN_ACCOUNT_STATUS_DIALOG_ID =
    "update-admin-account-status-dialog";

  static readonly TRUE = "true";
  static readonly FALSE = "false";

  static readonly MERGE = "merge";
  static readonly CENTER = "center";
  static readonly BOTTOM = "bottom";
  static readonly TOP = "top";

  static readonly BODY = "body";
  static readonly VISIBLE = "visible";
  static readonly COLLAPSE = "collapse";

  //Panel Class
  static readonly MAT_TOOLBAR = "mat-toolbar";
  static readonly BG_SUCCESS = "bg-success";
  static readonly BG_ERROR = "bg-error";
  static readonly BG_WARNING = "bg-warning";
  static readonly MAT_PRIMARY = "mat-primary";
  static readonly LEARNING_PLAN_MAT_CARD = ".learning-plan-mat-card";
  static readonly LARGE_PANEL = "largePanel";
  static readonly SMALL_PANEL = "smallPanel";

  //QA tabs
  static readonly ZERO = "0";
  //Expansion panel
  static readonly LEARNING_EXPANSION = "learningExpansionPanels";
  static readonly MAT_EXPANSION = "mat-expansion";
  static readonly MAT_ACCORDIOM_RESULTS = "_results";
  static readonly MAT_EXPANSION_EXPANDED = "mat-expansion-panel.mat-expanded";

  //Table
  static readonly ASCENDING = "asc";
  static readonly DESCENDING = "desc";
  static readonly ROW: string = "row";
  static readonly TABLE_ROW_EXPANSION = "table-row-expansion";
  static readonly TABLE_ROW_EXPANDED = ".table-row-expanded";

  static readonly ASCENDING_WORD = "ascending";
  static readonly DESCENDING_WORD = "descending";

  static readonly SORT_FIRSTNAME: string = "sortFirstName";
  static readonly SORT_LASTNAME: string = "sortLastName";
  static readonly SORT_USERNAME: string = "sortUsername";
  static readonly SORT_EMAIL: string = "sortEmail";

  static readonly SELECT_CHECKBOX = "selectCheckbox";
  static readonly SELECT: string = "select";
  static readonly DESELECT: string = "deselect";
  static readonly ALL: string = "all";
  static readonly SELECTED_INDEX = "selectedIndex";

  //Path
  static readonly CONFIG_PATH: string = "./assets/environment/app.config.json";
  static readonly REPOS_PATH: string = "/repos";
  //Common character constants
  static readonly SLASH: string = "/";
  static readonly DOUBLE_SLASH: string = "//";
  static readonly AMPSERSAND: string = "&";
  static readonly SECTION_DELIM: string = "-";
  static readonly SECTION_DELIM_UNICODE: string = "‑";
  static readonly VERTICAL_SECTION_DELIM: string = "||";
  static readonly UNDERSCORE_DELIM: string = "_";
  static readonly DOUBLE_UNDERSCORE_DELIM: string = "__";
  static readonly EQUALS: string = "=";
  static readonly GLOBAL_MODIFIER: string = "g";
  static readonly PERIOD: string = ".";
  static readonly RELATIVE_PATH: string = "../";
  static readonly STRING_VALUE: string = "string";
  static readonly COMMA_DELIM: string = ", ";
  static readonly PERCENT: string = "%";
  static readonly COMMA: string = ",";
  static readonly SEMI_COLON: string = ";";
  static readonly STRING_VALUE_ONE: string = "1";
  static readonly STRING_VALUE_OPACITY_03: string = "0.3";
  static readonly STRING_OBJECT: string = "object";
  static readonly UTF8BOM: string = "\uFEFF";  
  static readonly CURRENT_PATH: string = "./";

  //Error Codes
  static readonly NOTFOUND_404: string = "404";

  static readonly DELETE = "DELETE";
  static readonly PUT = "PUT";
  static readonly POST = "POST";
  static readonly GET = "GET";
  static readonly CONTENT_TYPE_HEADER: string = "Content-Type";
  static readonly AUTHORIZATION_HEADER: string = "Authorization";
  static readonly BEARER_PREFIX: string = "Bearer ";
  static readonly APPLICATION_JSON: string = "application/json";
  static readonly DEFAULT_TOKEN_REFRESH_INTERVAL_MS: number = 240000;

  static readonly TEXT: string = "text";

  static readonly AMBER_TABLE_MESSAGE: string =
    "I need to keep working on this";
  static readonly GREEN_TABLE_MESSAGE: string =
    "I am making good progress with this";
  static readonly RED_TABLE_MESSAGE: string = "I may need help with this";
  static readonly RAG_RESULT_TUTOR: string = "skill at this level";
  static readonly COLOR_AMBER: string = "amber";
  static readonly COLOR_GREEN: string = "green";
  static readonly COLOR_RED: string = "red";
  static readonly COLOR_LABEL_REQUIRED: string = "rgba(244,67,54,255)";

  static readonly SKILL_CHECK_OBJECT_ID: string = "skillsCheckObjectId";
  static readonly TOPIC_ID: string = "topicId";
  static readonly OVERALL: string = "Overall";
  static readonly OVERALL_LOWERCASE: string = "overall";
  static readonly REMINDER: string = "reminder";
  static readonly WRITTEN_ASSIGNMENTS: string = "writtenAssignments";

  //Validation property constants
  static readonly PASSWORD_MISMATCH = "passwordMismatch";
  static readonly EMAIL_MISMATCH = "emailMismatch";
  static readonly EMAIL_EXISTS = "emailExists";
  static readonly USERNAME_EXISTS = "usernameExists";
  static readonly SAME_EMAIL = "sameEmail";
  static readonly REQUIRED = "required";
  static readonly PATTERN = "pattern";
  static readonly MINLENGTH = "minlength";
  static readonly MAXLENGTH = "maxlength";
  static readonly VALID: string = "VALID";
  static readonly INVALID: string = "INVALID";
  //Validation error properties
  static readonly IS_USED: string = "isUsed";
  static readonly LOADING: string = "loading";
  static readonly DEFAULT_NOT_ALLOWED: string = "defaultNotAllowed";

  //Confirmation Message
  static readonly DIRTY_FORM: string = $localize`:@@confirm-form-incomplete:Changes have been made but not saved.\nWould you like to proceed with leaving this page?`;
  static readonly UNTICK_SELECTION: string = $localize`:@@confirm-untick:This action will untick all selected records. Do you want to continue?`;
  static readonly UNTICK_GROUP_SELECTION: string = $localize`:@@confirm-untick:This action will untick all selected group records. Do you want to continue?`;
  static readonly POPUP_CONFIRMATION: string = $localize`:@@pop-up-reminder-confirmation:By clicking \`OK\`, you are deferring your Skill Checks for seven (7) days. Should you wish to take a Skills Check immediately, please select \`Cancel\`.`;
  static readonly UNTICK_FORM_ADMINISTRATOR_ORGANISATION_SELECTION: string = $localize`:@@confirm-untick:This action will untick all selected organisations. Do you want to continue?`;
  static readonly NONE = "none";

  static readonly PAGINATOR = "paginator";

  //constants for queryparams
  static readonly FILTER_ORG: string = "filterOrganisation";
  static readonly FILTER_CENTRE: string = "filterCentre";
  static readonly FILTER_KEY: string = "filterKey";
  static readonly PERMISSION_ID_QUERY: string = "permissionId";

  //Component Element ID
  //Learning Plan
  static readonly LP_EXPANSION_HEADER: string =
    "learning-plan-expansion-header";
  static readonly VISITED_ICON: string = "check_circle";
  static readonly INNERTEXT: string = "innerText";
  static readonly INNERHTML: string = "innerHTML";
  static readonly CLASSLIST: string = "classList";
  static readonly MORE_TOGGLE: string = "more-toggle";
  static readonly IS_PREENTRY: string = "isPreEntry";
  static readonly SUBCATEGORYCODE: string = "subCategoryCode";

  //Strong Type
  static readonly BOOLEAN: string = "boolean";

  static readonly AVAILABLE: string = "available";
  static readonly UNAVAILABLE: string = "unavailable";

  //Group
  static readonly GROUP_NAME: string = "groupName";
  static readonly GROUP_NAME_EXIST: string = "Group name already exists.";
  static readonly DEFAULT_GROUP_NOT_ALLOWED: string =
    "Default keyword can not be used while creating new groups.";
  static readonly DEFAULT_KEYWORD_NOT_ALLOWED_UPDATE: string =
    "Default keyword group name can not be use.";
  static readonly GROUP_ARRAY: string = "groupArray";
  static readonly GROUP: string = "group";
  static readonly GROUPS_NAME: string = "groups";
  static readonly ALL_ORGANISATION_LABEL_TEXT = $localize`:@@all-organisations:All Organisations`;
  static readonly SELECT_ORGANISATION_LABEL_TEXT = $localize`:@@select-organisations:Select Organisation`;
  static readonly GROUP_IDS: string = "groupIds";

  //Centre
  static readonly CENTRE_UP: string = "Centre";
  static readonly CENTRE: string = "centre";
  static readonly CENTRE_ARRAY: string = "centreArray";

  //GroupList Constants
  static readonly NAME: string = "name";
  static readonly TUTORS: string = "tutors";
  static readonly LEARNERS: string = "learners";
  static readonly GROUP_ID: string = "groupId";
  static readonly SELECT_ALL: string = "selectAll";
  static readonly PAGE_INDEX: string = "pageIndex";
  //Mat config
  static readonly NOOP: string = "noop";
  static readonly CHECK: string = "check";

  //Truncate constants
  static readonly ELLIPSIS: string = "...";
  static readonly MORE_ELEM: string = "moreElement";
  static readonly PX15: string = "15px";
  static readonly PX0: string = "0px";
  static readonly MORE: string = $localize`:@@more:More`;
  static readonly LESS: string = $localize`:@@less:Less`;

  //Tutor
  static readonly TUTOR: string = "tutor";

  static readonly EMAIL_ALREADY_EXISTS: string = $localize`:@@email-exists:Email already exists.`;
  static readonly EMAIL_ALREADY_EXISTS_EN: string = "Email already exists.";

  static readonly USERNAME_ALREADY_EXISTS: string = $localize`:@@userName-exists:Username already exists.`;
  static readonly USERNAME_ALREADY_EXISTS_EN: string =
    "Username already exists.";

  static readonly EMAIL_USERNAME_ALREADY_EXISTS: string = $localize`:@@username-email-exists:Username and Email already exists.`;
  static readonly EMAIL_USERNAME_ALREADY_EXISTS_EN: string =
    "Username and Email already exists.";

  static readonly SELECT_ORG_AND_CENTRE: string = $localize`:@@first-choose-org:First, choose an organisation and its associated centres.`;
  static readonly ADD_ORG_INSTRUCTION: string = $localize`:@@click-add-organisation:Click '+ Add Organisation' to save selected organisation and centres.`;
  static readonly ORG_OPTION_INSTRUCTION: string = $localize`:@@tap-an-organisation:Tap on an organisation to reveal available options.`;

  static readonly USER_NOT_ASSOCIATED_WITH_LEARNER: string = $localize`:@@user-not-associated-with-learner:User is not associated with Learner`;
  static readonly USER_NOT_ASSOCIATED_WITH_LEARNER_EN: string =
    "User is not associated with Learner";

  static readonly NO_ACCESS_TO_LEARNER_REDIRECT: string = $localize`:@@no-access-to-learner-redirect:No access to learner. Redirecting to list.`;

  static readonly NO_ACCESS_TO_COURSE_REDIRECT: string = $localize`:@@no-access-to-course-redirect:No access to course. Redirecting to list.`;
  static readonly NO_ACCESS_TO_COURSE_REDIRECT_EN: string =
    "No access to course. Redirecting to list.";

  static readonly NO_ACCESS_TO_LEARNING_TAB_REDIRECT: string =
    "No access to learning tab. Redirecting to learning record.";
  static readonly NO_ACCESS_TO_TUTOR_REDIRECT: string =
    "No access to tutor. Redirecting to list.";
  static readonly ORG_CENTRE_ROW: string = "orgCentreRow";
  static readonly CENTRE_ROW: string = "centreRow";
  static readonly GROUP_ROW: string = "groupRow";
  static readonly GROUP_HAS_SELECTED_ORG: string = $localize`:@@group-required-selected-org:Group is required from all selected organisation.`;
  static readonly ORGANISATION_LIST_COLUMN: string = "organisationListColumn";
  static readonly CENTRE_LIST_COLUMN: string = "centreListColumn";
  static readonly GROUP_LIST_COLUMN: string = "groupListColumn";
  static readonly COURSE_LIST_COLUMN: string = "courseListColumn";
  static readonly TUTOR_UPDATE_SUCCESS: string = $localize`:@@updated-tutor-success:Successfully updated Tutor`;
  static readonly TUTOR_EDIT_LEARNER_FAILED: string = $localize`:@@tutor-edit-learner-failed-access:Tutor edit failed. Selected learner are associated with the organisation, centre, and groups to which the current user does not have access.`;
  static readonly TUTOR_ADD_LEARNER_FAILED: string = $localize`:@@tutor-add-learner-failed-access:Tutor add failed. Selected learner are associated with the organisation, centre, and groups to which the current user does not have access.`;
  static readonly TUTOR_NOT_FOUND: string = $localize`:@@tutor-not-found:Tutor not found`;
  static readonly TUTOR_NO_SELECTED_MESSAGE: string =
    "You have not selected any tutors.";
  static readonly TUTOR_SUCCESSFUL_DELETE_MESSAGE: string =
    "Tutors deleted successfully.";
  static readonly TUTOR_EDIT_FAILED_DUE_ORG_ACCESS: string = $localize`:@@tutor-edit-tutor-failed-org-access:Tutor edit failed. Selected tutor are associated with the organisation to which the current user does not have access.`;
  static readonly TUTOR_DELETE_FAILED_DUE_ORG_ACCESS: string =
    "Tutor delete failed. One or more of the selected tutors are associated with the organisation to which the current user does not have access.";
  static readonly TUTOR_DISABLE_DUE_TO_ORG_ACCESS_FAILED: string =
    "Tutors disable failed. One or more of the selected tutors are associated with the organisation to which the current user does not have access.";
  static readonly TUTOR_DISABLE_DUE_TO_ORG_ACCESS_TRANSLATION: string = $localize`:@@tutor-disable-due-to-org-access:Tutors disable failed. One or more of the selected tutors are associated with the organisation to which the current user does not have access.`;
  static readonly TUTOR_ENABLE_DUE_TO_ORG_ACCESS_FAILED: string =
    "Tutors enable failed. One or more of the selected tutors are associated with the organisation to which the current user does not have access.";
  static readonly TUTOR_ENABLE_DUE_TO_ORG_ACCESS_TRANSLATION: string = $localize`:@@tutor-enable-due-to-org-access:Tutors enable failed. One or more of the selected tutors are associated with the organisation to which the current user does not have access.`;
  static readonly ADMIN_DISABLE_DUE_TO_ORG_ACCESS_FAILED: string =
    "Admins disable failed. One or more of the selected admins are associated with the organisation to which the current user does not have access.";
  static readonly ADMIN_DISABLE_DUE_TO_ORG_ACCESS_TRANSLATION: string = $localize`:@@admin-disable-due-to-org-access:Admins disable failed. One or more of the selected admins are associated with the organisation to which the current user does not have access.`;
  static readonly ADMIN_ENABLE_DUE_TO_ORG_ACCESS_FAILED: string =
    "Admins enable failed. One or more of the selected admins are associated with the organisation to which the current user does not have access.";
  static readonly ADMIN_ENABLE_DUE_TO_ORG_ACCESS_TRANSLATION: string = $localize`:@@admin-enable-due-to-org-access:Admins enable failed. One or more of the selected admins are associated with the organisation to which the current user does not have access.`;

  // Role text
  static readonly SYSTEM_ADMINISTRATOR = "System Administrator";
  static readonly GLOBAL_ADMINISTRATOR = "Global Administrator";
  static readonly ORGANISATIONAL_ADMINISTRATOR = "Organisational Administrator";
  static readonly ALL_ADMINISTRATORS = "All Administrators";
  static readonly ADMINISTRATOR_TYPE_COLUMN: string = "administratorTypeColumn";

  //Organisation
  static readonly ORG_ID: string = "orgId";
  static readonly ORG_IDS: string = "orgIds";
  static readonly TOGGLE: string = "toggle";
  static readonly ORG_TOGGLE: string = "orgToggle";
  static readonly SORT_DIRECTION: string = "sortDirection";
  static readonly SORT_ACTIVE: string = "sortActive";
  static readonly SEARCH_TEXT: string = "searchText";
  static readonly ORGANISATION_REQUIRED: string = $localize`:@@organisation-required:Organisation is required.`;
  static readonly CENTRE_REQUIRED: string = $localize`:@@centre-required:Centre is required.`;
  static readonly GROUP_REQUIRED: string = $localize`:@@group-required:Group is required.`;
  static readonly COURSE_REQUIRED: string = $localize`:@@course-required:Course is required.`;
  //Landing Pages
  static readonly NEGATIVE_INT_FILTER: string = "-1";

  static readonly IS_INITIAL_LOAD: string = "isInitialLoad";
  static readonly IS_FROM_TUTOR_PAGE: string = "isFromTutorPage";
  static readonly PAGE_NUMBER: string = "pageNumber";
  static readonly PAGE_LENGTH: string = "pageLength";
  static readonly SEARCH_FROM_LIST: string = "searchFromList";
  static readonly ALL_LEVELS: string = "All levels";
  static readonly ALL_MODULE_TYPES: string = "All types";
  static readonly ALL_SKILLS: string = "All skills";

  //Organisation Permission
  static readonly ORG_HAS_PERMISSION: string = "orgHasPermission";

  //EDIT LEARNER
  static readonly ORGANISATION_LEVEL: string = $localize`:@@organisation-level:ORGANISATION LEVEL`;
  static readonly CENTRE_LEVEL: string = $localize`:@@centre-level:CENTRE LEVEL`;
  static readonly LEARNER_UPDATE_SUCCESS: string = $localize`:@@success-update-learner:Successfully updated Learner`;

  //EDIT Group
  static readonly CHECKBOXES: string = "checkBoxes";
  static readonly CHECKBOX: string = "checkbox";
  static readonly USER_ID: string = "userId";
  static readonly SUCCESS_UPDATE_GROUP: string = $localize`:@@success-edit-group:Successfully updated Group`;
  static readonly POSTFIX_REDIRECT_GROUP_LIST: string = $localize`:@@redirect-group-list:. Redirecting back to group list.`;
  static readonly DEFAULT: string = "default";

  //Learner: Add Offline Activity
  static readonly ACTIVITY_TITLE: string = "activityTitle";
  static readonly DATE_CREATED: string = "dateCreated";
  static readonly TIME_TAKEN: string = "timeTaken";
  static readonly SCORE: string = "score";
  static readonly LEVEL: string = "level";
  static readonly SKILL: string = "skill";
  static readonly COMMENT: string = "comment";
  static readonly ADD_OFFLINE_ACTIVITY_SUCCESS: string = $localize`:@@successfully-created-offline-activity:Successfully created offline activity`;
  static readonly UPDATE_OFFLINE_ACTIVITY_SUCCESS: string = $localize`:@@successfully-updated-offline-activity:Successfully updated offline activity`;

  //Account Status
  static readonly ENABLED: string = "enabled";
  static readonly DISABLED: string = "disabled";
  static readonly ENABLED_2: string = "Enabled";
  static readonly DISABLED_2: string = "Disabled";

  //Editor Config
  static readonly NO: string = "no";
  static readonly YES: string = "yes";
  static readonly P: string = "p";

  //Edit Learing plan messages
  static readonly EDIT_LEARNING_PLAN: string = "editlearningplan";
  static readonly MANUAL_EDIT_LEARNING_PLAN: string = "manualeditlearningplan";
  static readonly SUCCESS_EDIT_LEARNING_PLAN: string = $localize`:@@success-edit-learning-plan:Successfully updated Learning plan`;
  static readonly ERROR_EDIT_LEARNING_PLAN: string = $localize`:@@failed-edit-learning-plan:Failed updating Learning plan`;
  static readonly CONFIRM_GENERATE_LEARNING_PLAN: string =
    "Generating Entry 1 learning plan is irreversible and you can't go back to Pre-entry. \nDo you wish to continue?";

  //Manual edit learning plan
  static readonly CATEGORY_NAME = "categoryName";
  static readonly CURRENT_LEVEL = "currentLevel";
  static readonly TARGET_LEVEL = "targetLevel";
  static readonly CATEGORY_CODE = "categoryCode";

  //CategoryCode
  static readonly READING_CODE = "reading";
  static readonly WRITING_CODE = "writing";
  static readonly RW_CODE = "rw";
  static readonly RT_CODE = "rt";
  static readonly RF_CODE = "rf";
  static readonly WT_CODE = "wt";
  static readonly WS_CODE = "ws";
  static readonly WP_CODE = "wp";
  static readonly WG_CODE = "wg";
  static readonly SL_CODE = "sl";
  static readonly UD_CODE = "ud";
  static readonly WN_CODE = "wn";
  static readonly FDP_CODE = "fdp";
  static readonly MMT_CODE = "mmt";
  static readonly SSP_CODE = "ssp";
  static readonly PRS_CODE = "prs";
  static readonly FE_CODE = "fe";
  static readonly SP_CODE = "sp";
  static readonly DRES_CODE = "dres";
  static readonly DPROD_CODE = "dprod";
  static readonly DINF_CODE = "dinf";
  static readonly DCOLLAB_CODE = "dcollab";
  static readonly DCREATE_CODE = "dcreate";
  static readonly DLEARN_CODE = "dlearn";

  //Learning Resources
  static readonly AVAILABLE_RESOURCES: string = "availableResources";
  static readonly ALLOCATED_RESOURCES: string = "allocatedResources";
  static readonly DUEDATE: string = "dueDate";

  //Angular material inner HTML controls
  static readonly MAT_BUTTON_WRAPPER: string = "mat-button-wrapper";
  static readonly MAT_PSEUDO_CHECKBOX: string = "mat-pseudo-checkbox";
  static readonly INPUT_TYPE_CHECKBOX: string =
    "input.mdc-checkbox__native-control";
  static readonly DIV_CHECKBOX_INSERTED: string =
    "div.mdc-checkbox.ng-star-inserted";
  static readonly MDC_LIST_ITEM_PRIMARY_TEXT: string =
    "mdc-list-item__primary-text";
  static readonly MDC_LIST_ITEM_CONTENT: string = "mdc-list-item__content";
  static readonly HTML_CHART_CLASS_ARC = ".arc";
  static readonly HTML_CHART_ATTRIBUTE_FILL = "fill";
  static readonly HTML_CHART_ATTRIBUTE_STROKE = "stroke";
  static readonly HTML_CHART_ATTRIBUTE_STROKE_WIDTH = "stroke-width";
  static readonly HTML_CHART_LEGEND_NAME = "ngx-charts-legend-entry";
  static readonly HTML_NG_CHART_FORMAT_LEVEL = "ng-reflect-formatted-label";
  static readonly HTML_CLASS = "class";
  static readonly HTML_ACTIVE = "active";

  static readonly ITEMS_PER_PAGE_LABEL: string = $localize`:@@items-per-page:Items per page`;
  static readonly FIRST_PAGE_LABEL: string = $localize`:@@first-page:First page`;
  static readonly PREV_PAGE_LABEL: string = $localize`:@@prev-page:Previous page`;
  static readonly NEXT_PAGE_LABEL: string = $localize`:@@next-page:Next page`;
  static readonly LAST_PAGE_LABEL: string = $localize`:@@last-page:Last page`;

  static readonly GROUPS: string = $localize`:@@groups:groups`;

  //View Learning plan static
  static readonly OVERVIEW: string = $localize`:@@overview:Overview`;
  static readonly LEARNING_PLAN: string = $localize`:@@learning-plan-tab:Learning Plan`;
  static readonly LEARNING_RECORD_TAB: string = $localize`:@@learning-record-tab:Learning Record`;
  static readonly LEARNING_RECORD_TAB_DISABLED: string = $localize`:@@learning-record-disabled:Learning Record (Disabled while editing learning plan)`;

  //Edit admin page static messages
  static readonly CHANGE_SAVED: string = $localize`:@@changed-saved:Your changes have been saved.`;
  static readonly FAILED_EDIT_ADMIN: string = $localize`:@@failed-edit-admin:Failed: Updating administrator. Please try again.`;
  static readonly CHANGE_SAVED_GLOBAL: string = $localize`:@@updated-global-administrator:Successfully updated Global Administrator`;
  static readonly CHANGE_SAVED_ORG_ADMIN: string = $localize`:@@updated-org-administrator:Successfully updated Organisational Administrator`;
  static readonly ADMIN_NOT_ASSOCIATED: string = $localize`:@@admin-not-associated:Admin edit failed. Selected admin is associated with the organisation to which the current user does not have access.`;
  //Edit group static message:
  static readonly LEARNER_LABEL: string = $localize`:@@learner:Learner`;
  static readonly TUTOR_LABEL: string = $localize`:@@tutor:Tutor`;

  //Create organisation static messages
  static readonly SUCCESS_ADD_ORGANISATION: string = $localize`:@@success-add-organisation:Successfully added Organisation and Centre`;

  //Edit organisation static messages
  static readonly SUCCESS_EDIT_ORGANISATION: string = $localize`:@@success-edit-organisation:Successfully updated Organisation`;

  //Edit centre static messages
  static readonly EDITING_CENTRE: string = $localize`:@@editing-the-centre:editing the centre.`;
  static readonly CREATING_CENTRE: string = $localize`:@@creating-new-centre:creating the new centre.`;
  static readonly EDITING_CENTRE_POSTFIX: string = $localize`:@@update-centre:update the centre`;
  static readonly CREATING_CENTRE_POSTFIX: string = $localize`:@@create-new-centre:create a new centre`;

  //Delete organisation messages
  static readonly DELETE_ORGANISATION_SUCCESS: string =
    "Successfully deleted Organisation";

  //delimeter for translation pipe contents
  static readonly HASH: string = "#";
  static readonly LOADING_LABLE: string = $localize`:@@loading-label:Loading...`;
  static readonly DETAILS_ABOUT: string = $localize`:@@details-about:Details About `;

  //offline activity constant messages
  static readonly COMMENT_PLACEHOLDER: string = $localize`:@@comment-placeholder:Type your comment here...`;

  //create organisation
  static readonly ORGANISATION_PLACEHOLDER: string = $localize`:@@organisation:Organisation`;
  static readonly CENTRE_PLACEHOLDER: string = $localize`:@@centre:Centre`;

  //upsert centre
  static readonly CHOOSE_AN_ORGGANISATION: string = $localize`:@@choose-organisation:Choose an organisation`;

  //list data label
  static readonly DATA_LABEL_FIRSTNAME: string = $localize`:@@firstName:Firstname`;
  static readonly DATA_LABEL_LASTNAME: string = $localize`:@@lastName:Lastname`;
  static readonly DATA_LABEL_USERNAME: string = $localize`:@@userName:Username`;
  static readonly DATA_LABEL_ORGANISATION: string = $localize`:@@organisation:Organisation`;
  static readonly DATA_LABEL_CENTRE: string = $localize`:@@centre:Centre`;
  static readonly DATA_LABEL_GROUPS: string = $localize`:@@groups:Groups`;
  static readonly DATA_LABEL_COURSES: string = $localize`:@@courses:Courses`;
  static readonly DATA_LABEL_ADMIN_ROLE: string = $localize`:@@administrator-role:Administrator Role`;
  static readonly DATA_LABEL_NAME: string = $localize`:@@name:Name`;
  static readonly DATA_LABEL_NO_OF_TUTORS: string = $localize`:@@no-tutors:No. of Tutors`;
  static readonly DATA_LABEL_NO_OF_LEARNERS: string = $localize`:@@no-learners:No. of Learners`;
  static readonly DATA_LABEL_NO_OF_CENTRES: string = $localize`:@@no-of-centres:No. of Centres`;
  static readonly DATA_LABEL_EVENT: string = $localize`:@@event:Event`;
  static readonly DATA_LABEL_DATE: string = $localize`:@@table-date:Date`;
  static readonly DATA_LABEL_TIME: string = $localize`:@@table-time:Time`;
  static readonly DATA_LABEL_COURSE: string = $localize`:@@course_pc:Course`;
  static readonly DATA_LABEL_ASSESSMENT_START_LVL: string = $localize`:@@assessment-start-lvl:Assessment start level`;
  static readonly CENTRE_NAME_PLACEHOLDER: string = $localize`:@@step-centre-name-label:Centre name`;

  //Assessment
  static readonly EXTERNAL_RESULT: string = "External";
  static readonly WEST_RESULT: string = "WEST";
  static readonly ASSESSMENT_RESULT: string = "assessmentResult";
  static readonly CONFIRM_EXT_INIT_ASSESS: string = "confirmExtInitAssessment";
  static readonly ADD_EXTERNAL_INIT_ASSESSMENT_SUCCESS: string = $localize`:@@successfully-created-external-initial-assessment:Successfully created external initial assessment`;
  static readonly NO_UNSARTED_COURSE_FOUND: string = $localize`:@@no-unstarted-course-found:No unstarted courses found.`;
  static readonly NO_AVAILABLE_COURSE_FOUND: string = $localize`:@@no-available-course-found:No available courses found.`;
  static readonly EXT_ASSESSMENT_ADD_FAILED_COURSE_STATUS: string =
    "Operation failed. One or more courses changed status.";
  static readonly ACCESS_DENIED_PERMISSION: string =
    "Access Denied: You do not have the necessary permissions to execute this operation.";
  static readonly EXTERNAL_INIT_ASSESSMENT_TOOLTIP_MESSAGE =
    "This facility is for tutors and administrators who have learners who completed an initial assessment outside WEST";
  static readonly COURSE_ICON_PATH: string = "courseIconPath";

  //Course Current Progress
  static readonly ASSESSMENT_NOT_STARTED: string = "Assessment (not started)";
  static readonly ASSESSMENT_INCOMPLETE: string = "Assessment (incomplete)";
  static readonly ASSESSMENT_COMPLETE: string = "Assessment (complete)";
  static readonly ASSIGN_TARGETS: string = "Assign Targets";

  //Transfer process constants
  static readonly USERNAME_EMAIL_REQUIRED: string =
    "Search by Username or Email";
  static readonly USERNAME_OR_EMAIL: string = "usernameOrEmail";
  static readonly CONFIRMED: string = "confirmed";
  static readonly APPLICATION_OF_NUMBERS: string = "applicationOfNumbers";
  static readonly COMM_ENGLISH: string = "commEnglish";
  static readonly COMM_WELSH: string = "commWelsh";
  static readonly DIGITAL_LIT: string = "digLit";
  static readonly DIGITAL_LIT_SELF_ASSESS: string = "digLitSelfAssess";
  static readonly REQUEST_SUCCESS_DIALOG_ID: string = "request-success-dialog";
  static readonly REQUEST_INSTRUCTION_DIALOG_ID: string =
    "request-instruction-dialog";
  static readonly CONFIRM_TRANSFER_DIALOG_ID: string =
    "confirm-transfer-dialog";
  static readonly AGREE_CONTAINER_ID: string = "agreeContainer";
  static readonly SHAKE_CLASS: string = "shake";
  static readonly INVALID_CLASS: string = "invalid";
  static readonly HORIZONTAL: StepperOrientation = "horizontal";
  static readonly VERTICAL: StepperOrientation = "vertical";
  static readonly TRANSFER_CENTRE_SUCESS: string = $localize`:@@transfer-centre-success:Transfer of Centre Successful`;
  static readonly TRANSFER_CENTRE_FAILED: string = $localize`:@@transfer-centre-fail:Transfer of Centre Failed`;

  //Delete organisation constants
  static readonly DELETE_ORG_DIALOG_ID: string =
    "delete-organisation-dialog-id";

  //disable delete instruction constants
  static readonly DISABLE_DELETE_DIALOG_ID: string =
    "disable-delete-instruction-dialog";

  static readonly TOOLTIP: string = "/tooltip/";
  static readonly IS_NEW_DIG_LIT: string = "isNewDigLit";
  static readonly DIG_LIT_SELF_ASSESSMENT_SAVE_SUCCESSFUL: string =
    "Successfully saved Digital Literacy Self-Assessment";
  static readonly DIG_LIT_SELF_ASSESSMENT_SAVE_ERROR: string =
    "Failed saving Digital Literacy Self-Assessment";
  static readonly DIG_LIT_TOOLTIP_ICON: string =
    '<span class="pl-1 dig-lit-info-icons material-icons fs-14">info</span>';
  static readonly DIG_LIT_TOOLTIP_ICON_DISABLED: string =
    '<span class="pl-1 dig-lit-info-icons-disabled material-icons fs-14">info</span>';
  static readonly DIG_LIT_INFO_ICON: string = "dig-lit-info-icons";
  static readonly DIG_LIT_INFO_ICON_DISABLED: string =
    "dig-lit-info-icons-disabled";

  //Reset mfa constants
  static readonly MFA_CONFIRMATION_DIALOG_ID: string = "reset-mfa-dialog";
  static readonly SUCCESS_RESET_MFA: string = "MFA has been successfully reset";
  static readonly ERROR_RESET_MFA: string = "MFA reset was unsuccessful";

  //Reports constants
  static readonly REPORT_TYPE: string = "reportType";
  static readonly ACTIVITY: string = "activity";
  static readonly LEARNER_REPORTS: string = "Learner reports";
  static readonly AGGREGATE_REPORTS: string = "Aggregate reports";
  static readonly SCREENER_REPORTS: string = "Screener reports";
  static readonly STATUS_VALUE: string = "StatusValue";
  static readonly DATE_FROM: string = "dateFrom";
  static readonly DATE_TO: string = "dateTo";
  static readonly ACCOUNT_CREATE_FROM: string = "accountCreatedFrom";
  static readonly ACCOUNT_CREATE_TO: string = "accountCreatedTo";
  static readonly ACCOUNT_ACTIVITY_FROM: string = "accountActivityFrom";
  static readonly ACCOUNT_ACTIVITY_TO: string = "accountActivityTo";
  static readonly ACCOUNT_CREATE_DATE: string = "accountCreatedDate";
  static readonly ACCOUNT_ACTIVITY_DATE: string = "accountActivityDate";
  static readonly DATE_COMPLETED: string = "dateCompleted";
  static readonly DATE_COMPLETED_FROM: string = "dateCompletedFrom";
  static readonly DATE_COMPLETED_TO: string = "dateCompletedTo";
  static readonly COURSE_STATUS: string = "courseStatus";
  static readonly CURRENT_STEP: string = "currentStep";
  static readonly CURRENTLY_AT: string = "currentlyAt";
  static readonly CURRENT_AT: string = $localize`:@@currently-at-header:Currently at`;
  static readonly INITIAL_ASSESSMENT: string = "initialAssessment";
  static readonly LAST_ACTIVITY_DATE: string = "lastActivityDate";
  static readonly DATE_EXCEEDS: string = "dateExceeds";
  static readonly LAST_OL_SIGN_IN: string = "lastOnlineSignin";
  static readonly COURSE_HEADER: string = "course";
  static readonly COURSES_LC: string = "courses";
  static readonly OTHER: string = "Other";
  static readonly ASSESSMENT_COMPLETED_AT_ORG: string = "completedAtOrg";
  static readonly OVERALL_RESULT: string = "overallResult";
  static readonly TAB_INDEX: string = "tabIndex";

  //Report Type constants
  static readonly LEARNERS_RT: string = "Learners";
  static readonly LEARNER_ACT_RT: string = "Learner Activity";
  static readonly APP_NUMBER_RT: string =
    "Application of Number distance travelled";
  static readonly COMM_ENGLISH_RT: string =
    "Communication (English) distance travelled";
  static readonly COMM_WELSH_RT: string =
    "Communication (Welsh) distance travelled";
  static readonly DIG_LIT_RT: string = "Digital Literacy distance travelled";
  static readonly DIG_LIT_SELF_ASSESS_RT: string =
    "Digital Literacy Self-Assessment distance travelled";
  static readonly OVERALL_INIT_ASSESS_RESULT_RT: string =
    "Overall initial assessment result";
  static readonly APP_NUMBER_INIT_ASSESS_BREAKDOWN_RT: string =
    "Application of Number initial assessment breakdown";
  static readonly COMM_ENGLISH_INIT_ASSESS_BREAKDOWN_RT: string =
    "Communication (English) initial assessment breakdown";
  static readonly COMM_WELSH_INIT_ASSESS_BREAKDOWN_RT: string =
    "Communication (Welsh) initial assessment breakdown";
  static readonly DIG_LIT_INIT_ASSESS_BREAKDOWN_RT: string =
    "Digital Literacy initial assessment breakdown";
  static readonly APP_NUMBER_SKILL_RT: string =
    "Application of Number distance travelled (by skill)";
  static readonly COMM_ENGLISH_SKILL_RT: string =
    "Communication (English) distance travelled (by skill)";
  static readonly COMM_WELSH_SKILL_RT: string =
    "Communication (Welsh) distance travelled (by skill)";
  static readonly DIG_LIT_SKILL_RT: string =
    "Digital Literacy distance travelled (by skill)";
  static readonly DIG_LIT_SELF_ASSESS_SKILL_RT: string =
    "Digital Literacy Self-Assessment distance travelled (by skill)";
  static readonly LEARNER_STATISTICS_ALL_COURSES_RT: string = "Learner statistics (all courses)";
  static readonly LEARNER_STATISTICS_SINGLE_COURSE_RT: string = "Learner statistics (single course)";
  static readonly SCREENER_STATISTICS_ALL_COURSES_RT: string = "Screener statistics (all courses)";
  static readonly SCREENER_STATISTICS_SINGLE_COURSE_RT: string = "Screener statistics (single course)";
  static readonly INITIAL_ASSESSMENT_STATISTICS_ALL_COURSES_RT: string = "Initial assessment statistics (all courses)";
  static readonly INITIAL_ASSESSMENT_STATISTICS_SINGLE_COURSE_RT: string = "Initial assessment statistics (single course)";
  static readonly OVERALL_SCREENER_RESULT_RT: string = "Overall screener result";
  //Report tab title
  static readonly LEARNER_STATISTICS_ALL_COURSES: string = "learner_statistics_all_courses";
  static readonly LEARNER_STATISTICS_SINGLE_COURSE: string = "learner_statistics_single_course";
  static readonly SCREENER_STATISTICS_ALL_COURSES: string = "screener_statistics_all_courses";
  static readonly SCREENER_STATISTICS_SINGLE_COURSE: string = "screener_statistics_single_course";
  static readonly INITIAL_ASSESSMENT_STATISTICS_ALL_COURSES: string = "initial_assessment_statistics_all_courses";
  static readonly INITIAL_ASSESSMENT_STATISTICS_SINGLE_COURSE: string = "initial_assessment_statistics_single_course";
  static readonly APP_NUMBER_DISTANCE_TRAVEL = "app_number_distance_travel";
  static readonly COMM_ENGLISH_DISTANCE_TRAVEL = "comm_english_distance_travel";
  static readonly COMM_WELSH_DISTANCE_TRAVEL = "comm_welsh_distance_travel";
  static readonly DIG_LIT_DISTANCE_TRAVEL = "dig_lit_distance_travel";
  static readonly DIG_LIT_SELF_ASSESS_DISTANCE_TRAVEL =
    "dig_lit_self_assess_distance_travel";
  static readonly APP_NUMBER_INITIAL_ASSESSMENT_BREAKDOWN_NAME =
    "application_of_number_initial_assessment_breakdown";
  static readonly COMM_ENGLISH_INITIAL_ASSESSMENT_BREAKDOWN_NAME =
    "comm_english_initial_assessment_breakdown";
  static readonly COMM_WELSH_INITIAL_ASSESSMENT_BREAKDOWN_NAME =
    "comm_welsh_initial_assessment_breakdown";
  static readonly DIG_LIT_INITIAL_ASSESSMENT_BREAKDOWN_NAME =
    "dig_lit_initial_assessment_breakdown";
  static readonly OVERALL_INIT_ASSESS_RESULT_NAME =
    "overall_initial_assessment_result";
  static readonly APP_NUMBER_DISTANCE_TRAVEL_SKILL =
    "app_number_distance_travel_skill";
  static readonly COMM_ENGLISH_DISTANCE_TRAVEL_SKILL =
    "comm_english_distance_travel_skill";
  static readonly COMM_WELSH_DISTANCE_TRAVEL_SKILL =
    "comm_welsh_distance_travel_skill";
  static readonly DIG_LIT_DISTANCE_TRAVEL_SKILL =
    "dig_lit_distance_travel_skill";
  static readonly DIG_LIT_SELF_ASSESS_DISTANCE_TRAVEL_SKILL =
    "dig_lit_self_assess_distance_travel_skill";
  static readonly OVERALL_SCREENER_RESULT = "overall_screener_result";

  //Report Details
  static readonly ACCOUNT_STATUS_RD: string = "Account status";
  static readonly COURSE_STATUS_RD: string = "Course status";
  static readonly INIT_ASSESSMENT_RD: string = "Initial assessment";
  static readonly DIG_LIT_SA_NAME: string = "Digital Literacy Self-Assessment";
  static readonly OVERALL_RESULT_CHART_TITLE: string = "Overall result";
  static readonly INCLUDED_ASSESSMENTS_COMPLETED_AT: string =
    "Include assessments completed at";
  static readonly MY_ORGANISATION: string = "My Organisation";

  //Export Type
  static readonly HTML_EXPORT = "html";
  static readonly DOCX_EXPORT = "docx";
  static readonly CSV_EXPORT = "csv";
  static readonly PDF_EXPORT = "pdf";

  //Idle Event
  static readonly IDLE_STOP: string = "stop";
  static readonly IDLE_START: string = "start";

  //Dig lit self assessment audio
  static readonly FORCE_MUTE: string = "forceMute";
  static readonly FORCE_PAUSE: string = "forcePause";

  static readonly CREATE_GROUPS: string = "create-group";
  static readonly CREATE_LEARNER: string = "create-learner";

  //fs-player
  static readonly FS_CONTENT_PLAYER_WEBAPP: string = "fs-content-player-webapp";
  static readonly FS_CONTENT_PLAYER_WEBAPP_CY: string =
    "fs-content-player-webapp-cy";
  static readonly FS_CONTENT_PLAYER: string = "fs-content-player";
  static readonly FS_CONTENT_PLAYER_CY: string = "fs-content-player-cy";
  static readonly FS_PLAYER_FULL_PATH = "fsPlayerFullpath";
  static readonly FS_PARAM_SESSION_ID = "session_id";
  static readonly FS_PARAM_OBJECT_ID = "object_id";
  static readonly DDD = "DDD";

  static readonly IS_ASSIGNMENT_PROP: string = "isAssignment";

  static readonly PRE_ENTRY: string = "Pre-entry";

  //distance travel skill
  static readonly SKILL_AREA: string = "skillArea";
  static readonly IA_OVERALL: string = "iaOverall";
  static readonly E1: string = "e1";
  static readonly E2: string = "e2";
  static readonly E3: string = "e3";
  static readonly L1: string = "l1";
  static readonly L2: string = "l2";
  static readonly L3: string = "l3";
  static readonly SUMMARY: string = "summary";
  static readonly SKILL_SELECT = "skillSelect";

  // B2C Forgot your password? constant
  static readonly FORGOT_YOUR_PASSWORD_ERROR_CODE = "AADB2C90118";
  static readonly ID_TOKEN_CLAIMS_ACR = "acr";
  static readonly B2C_SI_FORGOT_PW: string = "b2c_1a_signin_forgotpassword";

  static readonly ORGANISATIONS_CTRL: string = "organisations";

  //AggregateReports 
  static readonly AGGREGATE_REPORT_PATH: string = "aggregate-reports";
  static readonly REGISTERED: string = "registered";
  static readonly NO_ASSIGNED_COURSES: string = "noAssignCourses";
  static readonly NOTSTARTED: string = "notStarted";
  static readonly LEARNING: string = "learning"
  static readonly TOTAL_SCREENERS_BEGUN: string = "totalScreenersBegun";
  static readonly TOTAL_SCREENERS_COMPLETED: string = "totalScreenersCompleted";
  static readonly PRE_ENTRY_PROP: string = "preEntry";
  static readonly IA_COMPLETED: string = "iaCompleted";
  static readonly ORGANISATION_NAME_TEXT: string = $localize`:@@centre-details-organisation-name:Organisation name`;
  static readonly INITIAL_ASSESSMENT_COMPLETED_TEXT: string = $localize`:@@initial-assessment-completed:Initial assessment completed`;
  static readonly PRE_ENTRY_TEXT: string = $localize`:@@no-level:Pre-entry`;
  static readonly ENTRY1_TEXT: string = $localize`:@@entry-1:Entry 1`;
  static readonly ENTRY2_TEXT: string = $localize`:@@entry-2:Entry 2`;
  static readonly ENTRY3_TEXT: string = $localize`:@@entry-3:Entry 3`;
  static readonly LEVEL1_TEXT: string = $localize`:@@level-1:Level 1`;
  static readonly LEVEL2_TEXT: string = $localize`:@@level-2:Level 2`;
  static readonly LEVEL3_TEXT: string = $localize`:@@level-3:Level 3`;
  static readonly REGISTERED_TEXT: string = $localize`:@@registered:Registered`;
  static readonly NO_ASSIGNED_COURSES_TEXT: string = $localize`:@@no-assigned-courses:No assigned courses`;
  static readonly NOT_STARTED_TEXT: string = $localize`:@@not-started:Not started`;
  static readonly INITIAL_ASSESSMENT_TEXT: string = $localize`:@@initial-assessment-label:Initial assessment`;
  static readonly LEARNING_TEXT: string = $localize`:@@learning-record-tabs-learning:Learning`;
  static readonly TOTAL_SCREENERS_BEGUN_TEXT: string = $localize`:@@screeners-begun:Screeners begun`;
  static readonly TOTAL_SCREENERS_COMPLETED_TEXT: string = $localize`:@@screeners-completed:Screeners completed`;
  static readonly RESIZE_HANDLE: string = "resize-handle";
  static readonly MOUSE_DOWN: string = "mousedown";
  static readonly MOUSE_MOVE: string = "mousemove";
  static readonly MOUSE_UP: string = "mouseup";
  static readonly WIDTH: string = "width";
  static readonly CLICK: string = "click";

  //overall screener result
  static readonly TOTAL_TIME_TAKEN = "totalTimeTaken";
  static readonly SC_N_CODE = "sc_n";
  static readonly SC_L_CODE = "sc_l";
  static readonly SC_W_CODE = "sc_w";
  static readonly SC_D_CODE = "sc_d";
  static readonly APPLICATION_OF_NUMBER = "Application of Number";
  static readonly COMMUNICATION_ENGLISH = "Communication (English)";
  static readonly COMMUNICATION_WELSH = "Communication (Welsh)";
  static readonly DIGITAL_LITERACY = "Digital Literacy";

  static readonly VIEW_LEARNING_PLAN_RECORD_TAB_CONTENT_CLASS = ".view-learning-plan-learning-record-tab-content";
  static readonly PRINT_LEARNING_RECORD_CLASS = ".print-learning-record";

  static readonly ERROR_ADDING_SCREENER_RECORD = "Error adding screener record. Contact administrator.";

  // Truncate
  static readonly HIGHLIGHTED_TEXT_PLACEHOLDER: string = "$1";
  static readonly HIGHLIGHTED_TEXT_ELEMENT: string = `<span>$1</span>`;
}
